import React from "react";
import styled from "styled-components";
import tw from "tailwind.macro";

const ImageContainer = styled.div.attrs({
  className: "flex flex-col justify-center items-start p-4 h-full",
})`
  ${({ fullWidth }) => fullWidth && "max-width: 80%; margin-top:2rem;"}
  ${({ type }) =>
    type === "image"
      ? "max-height: 37.5rem; min-height: 50%; max-width: 50%;"
      : ""}
  ${({ type }) => (type === "video" ? "max-height: 90%; max-width: 90%;" : "")}
`;

const Description = styled.div`
  ${tw`flex flex-col items-center justify-center relative`}
`;

const StyleFlag = styled.div`
  ${tw`absolute inset-x-0 top-0 flex ml-8`}
  margin-top: -16%;
`;

const Text = styled.p`
  ${tw`font-franklin text-mattamy-gray text-sm italic pt-3 font-light text-center border-aqua ml-30-mattamy ml-8`}
  margin-top: -.375rem;
  border-top-width: 0.75rem;
`;

const CarouselImage = (props) => (
  <ImageContainer
    fullWidth={props.type === "tour"}
    className={props.flag ? "relative" : ""}
    type={props.type}
  >
    {props.type === "video" && (
      <video
        src={props.src}
        controls
        disablepictureinpicture="true"
        controlslist="nodownload"
      />
    )}
    {props.type === "image" && (
      <img
        className="block box-content object-center object-scale-down self-center"
        src={props.src || props.thumbnail}
        alt={props.alt}
      />
    )}
    {props.type === "tour" && (
      <div
        className="w-full -my-12"
        dangerouslySetInnerHTML={{ __html: props.src }}
      />
    )}
    {props.flag && (
      <StyleFlag>
        <span className="w-auto bg-white text-mattamy-gray uppercase font-trade-gothic-20 pt-1">
          {props.flag}
        </span>
      </StyleFlag>
    )}
    <Description>
      <Text>{props.description}</Text>
    </Description>
  </ImageContainer>
);

export default CarouselImage;
